import { render } from "./HomepageHeader.vue?vue&type=template&id=15b604c1"
import script from "./HomepageHeader.vue?vue&type=script&lang=js"
export * from "./HomepageHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__